var _require = require('./utils/utils'),
    isPlainObject = _require.isPlainObject;

var simplify = require('./helpers/simplify');

var parse = require('./helpers/parse_responses');

var helpers = require('./helpers/helpers');

var sitelinksHelpers = require('../lib/helpers/sitelinks');

var rankHelpers = require('../lib/helpers/rank');

var tip = "Tip: if you just want to access functions that don't need an instance or a sparqlEndpoint,\nthose are also exposed directly on the module object. Exemple:\nconst { isItemId, simplify } = require('wikibase-sdk')";
var common = Object.assign({
  simplify: simplify,
  parse: parse
}, helpers, sitelinksHelpers, rankHelpers);

var WBK = function WBK(config) {
  if (!isPlainObject(config)) throw new Error('invalid config');
  var instance = config.instance,
      sparqlEndpoint = config.sparqlEndpoint;

  if (!(instance || sparqlEndpoint)) {
    throw new Error("one of instance or sparqlEndpoint should be set at initialization.\n".concat(tip));
  }

  var wikibaseApiFunctions, instanceRoot, instanceApiEndpoint;

  if (instance) {
    validateEndpoint('instance', instance);
    instanceRoot = instance.replace(/\/$/, '').replace('/w/api.php', '');
    instanceApiEndpoint = "".concat(instanceRoot, "/w/api.php");

    var buildUrl = require('./utils/build_url')(instanceApiEndpoint);

    wikibaseApiFunctions = {
      searchEntities: require('./queries/search_entities')(buildUrl),
      getEntities: require('./queries/get_entities')(buildUrl),
      getManyEntities: require('./queries/get_many_entities')(buildUrl),
      getRevisions: require('./queries/get_revisions')(buildUrl),
      getEntityRevision: require('./queries/get_entity_revision')(instance),
      getEntitiesFromSitelinks: require('./queries/get_entities_from_sitelinks')(buildUrl)
    };
  } else {
    wikibaseApiFunctions = {
      searchEntities: missingInstance('searchEntities'),
      getEntities: missingInstance('getEntities'),
      getManyEntities: missingInstance('getManyEntities'),
      getRevisions: missingInstance('getRevisions'),
      getEntityRevision: missingInstance('getEntityRevision'),
      getEntitiesFromSitelinks: missingInstance('getEntitiesFromSitelinks')
    };
  }

  var wikibaseQueryServiceFunctions;

  if (sparqlEndpoint) {
    validateEndpoint('sparqlEndpoint', sparqlEndpoint);
    wikibaseQueryServiceFunctions = {
      sparqlQuery: require('./queries/sparql_query')(sparqlEndpoint),
      getReverseClaims: require('./queries/get_reverse_claims')(sparqlEndpoint)
    };
  } else {
    wikibaseQueryServiceFunctions = {
      sparqlQuery: missingSparqlEndpoint('sparqlQuery'),
      getReverseClaims: missingSparqlEndpoint('getReverseClaims')
    };
  }

  var parsedData = {
    instance: {
      root: instanceRoot,
      apiEndpoint: instanceApiEndpoint
    }
  };
  return Object.assign(parsedData, common, wikibaseApiFunctions, wikibaseQueryServiceFunctions);
}; // Make heplpers that don't require an instance to be specified available
// directly on the exported function object


Object.assign(WBK, common);

var validateEndpoint = function validateEndpoint(name, url) {
  if (!(typeof url === 'string' && url.startsWith('http'))) {
    throw new Error("invalid ".concat(name, ": ").concat(url));
  }
};

var missingConfig = function missingConfig(missingParameter) {
  return function (name) {
    return function () {
      throw new Error("".concat(name, " requires ").concat(missingParameter, " to be set at initialization"));
    };
  };
};

var missingSparqlEndpoint = missingConfig('a sparqlEndpoint');
var missingInstance = missingConfig('an instance');
module.exports = WBK;